import { useEffect, useState } from "react";
import { UserProfileIndex } from "@Src/features/UserProfile";
// import { SidebarIndex } from "@Src/features/UserProfile/Sidebar";
// import "./UserProfile.scss";
// import Header from "@Components/Header/Header";
// import { MobHeader } from "@Components/Mob-header/Mob-header";

import { DashboardSidebarIndex } from "@Src/features/Dashboard/Sidebar/Index"
import "@Src/features/Dashboard/Dashboard.scss";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { DashHeaderIndex } from "@Src/features/Dashboard/Dash-header/Dash-header";
import { AppRouteURL } from "@Constants/app-route-url.constant";


export const UserProfile = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!(location.pathname.startsWith(AppRouteURL.USERPROFILE)) || location.pathname.endsWith(AppRouteURL.USERPROFILE)) {
      navigate(AppRouteURL.NOT_FOUND)
    }
  }, [location.pathname])

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <div>
        <DashHeaderIndex toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="dashboard-container">
          <div className={`dashboard-sidebar ${isSidebarOpen ? 'show' : ''}`}>
            <DashboardSidebarIndex closeSidebar={() => setIsSidebarOpen(false)} />
          </div>
          <div className="dashboard-content-page" onClick={() => isSidebarOpen && setIsSidebarOpen(false)}>
            <UserProfileIndex />
          </div>
        </div>
        {isSidebarOpen && (
          <div
            className="sidebar-backdrop"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}
      </div>
    </>
  );
};
